namespace RioERP.Carts {
    export namespace CartProductBillingItemsTaxService {
        export const baseUrl = 'Carts/CartProductBillingItemsTax';

        export declare function Create(request: Serenity.SaveRequest<CartProductBillingItemsTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CartProductBillingItemsTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartProductBillingItemsTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CartProductBillingItemsTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Carts/CartProductBillingItemsTax/Create",
            Update = "Carts/CartProductBillingItemsTax/Update",
            Delete = "Carts/CartProductBillingItemsTax/Delete",
            Retrieve = "Carts/CartProductBillingItemsTax/Retrieve",
            List = "Carts/CartProductBillingItemsTax/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CartProductBillingItemsTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
